import firebase from "firebase";
import 'firebase/firestore';

var config = {
    apiKey: "AIzaSyA_-CO3yAT_qJkJP1BpHB6hrE3hzT24dZg",
    authDomain: "rkbaaz-621fc.firebaseapp.com",
    databaseURL: "https://rkbaaz-621fc.firebaseio.com",
    projectId: "rkbaaz-621fc",
    storageBucket: "rkbaaz-621fc.appspot.com",
    messagingSenderId: "120413854341"
};

const firebaseApp = firebase.initializeApp(config);

const database = firebaseApp.firestore();
database.settings({ timestampsInSnapshots: true });

const childrenRef = database.collection('children');
const usersRef = database.collection('users');
const contactsRef = database.collection('contacts');
const eventsRef = database.collection('events');
const paymentsRef = database.collection('payments');
const invitesRef = database.collection('invites');

const auth = firebase.auth();

const imagesRef = firebase.storage().ref('images');

const makePaymentCall = firebase.functions().httpsCallable('makePayment');

export { childrenRef, usersRef, contactsRef, eventsRef, auth, imagesRef, paymentsRef, invitesRef, makePaymentCall };



// WEBPACK FOOTER //
// ./src/firebase/index.js